import moment from 'moment';
import 'moment-timezone';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '@ally/date-utils';
import { getAccountId } from '@ally/transfer-account-utils';
import { allFrequencies, oneTime } from '../constants';
export var getFrequency = function (value) {
    var frequency = allFrequencies.find(function (f) { return f.value === value; });
    return frequency !== null && frequency !== void 0 ? frequency : oneTime;
};
function formValuesToTransfer(values, accounts, _a) {
    var transferSpeed = _a.transferSpeed, withdrawalDate = _a.withdrawalDate;
    return {
        fromAccount: accounts.find(function (account) { return getAccountId(account) === values.fromAccount; }),
        toAccount: accounts.find(function (account) { return getAccountId(account) === values.toAccount; }),
        amount: Number(values.amount),
        deliveryDate: moment.tz(values.deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE),
        distributionAmountType: values.distributionAmountType,
        distributionType: values.distributionType,
        federalWithholdingValue: values.federalWithholdingValue,
        federalWithholdingType: values.federalWithholdingType,
        stateWithholdingValue: values.stateWithholdingValue,
        stateWithholdingType: values.stateWithholdingType,
        transferSpeed: transferSpeed,
        withdrawalDate: withdrawalDate,
        noteToSelf: values.noteToSelf || '',
        frequency: getFrequency(values.frequency),
    };
}
export default formValuesToTransfer;
//# sourceMappingURL=formValuesToTransfer.js.map